export const PageHeading = ({heading}) => {
  return (
    <div className="container section-title" data-aos="fade-up">
      <h2>{heading}</h2>
    </div>
  );
};
